<template>
  <div class="custom-step" ref=scrollContainer>
    <div v-for="(item, index) in currentSteps"
      class="step-item"
      ref="stepItem"
      :class="[index === active && 'active-step', createStepItemClassName(item)]"
      :style="customStyle"
      :key="index"
      @click="onClick(index)"
    >
      <div class="step-top">
        <van-icon class="icon-top" :class="[item.iconClass]" :name="item.iconName" />
      </div>
      <div class="step-line">
        <div class="before-step" :class="index === 0 && 'first-step'"></div>
        <van-icon v-if="index === active" class="icon-step icon-active" :class="activeIconClass" :name="activeIconName" />
        <van-icon v-else-if="index < active" class="icon-step icon-finish" :class="finishIconClass" :name="finishIconName" />
        <van-icon v-else class="icon-step icon-inactive" :class="inactiveIconClass" :name="inactiveIconName" />
        <div class="after-step" :class="index === currentSteps.length - 1 && 'last-step'"></div>
      </div>
      <div class="step-title">
        <span class="title">{{ getStepTitle(item.title, item.titleI18nKey, item.stepType) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { STEP_TYPE } from '@/constant/candidate'

export default {
  props: {
    stepTypes: {
      type: Array,
      required: true
    },
    active: {
      type: Number,
      default: 0
    },
    activeIconClass: {
      type: String,
      default: 'iconfont icondot'
    },
    inactiveIconClass: {
      type: String,
      default: 'circle'
    },
    finishIconClass: {
      type: String,
      default: 'iconfont iconcompleted'
    },
    activeIconName: {
      type: String,
      default: 'iconfont icondot'
    },
    inactiveIconName: {
      type: String,
      default: 'circle'
    },
    finishIconName: {
      type: String,
      default: 'iconfont iconcompleted'
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      defaultSteps: [
        { iconClass: 'iconfont iconupload', stepType: STEP_TYPE.UPLOAD_RESUME },
        { iconClass: 'iconfont icona-basicinformation', stepType: STEP_TYPE.BASE_INFO },
        { iconClass: 'iconfont iconeducation', stepType: STEP_TYPE.EDUCATION },
        { iconClass: 'iconfont icona-workexperience', stepType: STEP_TYPE.WORK_EXPERIENCE },
        { iconClass: 'iconfont icona-AdditionalInformation', stepType: STEP_TYPE.ADDITIONAL_INFO },
        { iconClass: '', stepType: STEP_TYPE.SUBMIT_REFERRAL },
        { iconClass: 'iconfont icona-recruitercomments job-question-icon', stepType: STEP_TYPE.JOB_QUESTIONNAIRE },
        { iconClass: 'iconfont icona-recruitercomments invite-question-icon', stepType: STEP_TYPE.INVITE_QUESTIONNAIRE },
        { iconClass: 'iconfont icona-ViewResume resume-info-icon', stepType: STEP_TYPE.RESUME_INFO }
      ]
    }
  },
  computed: {
    currentSteps () {
      const currentSteps = []
      if (this.stepTypes) {
        _.forEach(this.stepTypes, item => {
          const step = _.find(this.defaultSteps, { stepType: item.stepType })
          if (step) {
            _.merge(step, item)
            currentSteps.push(step)
          }
        })
      }
      return currentSteps
    },
    customStyle () {
      return {
        width: `${100 / this.currentSteps.length}%`
      }
    }
  },
  mounted () {
    this.scrollToCenter()
  },
  methods: {
    getStepTitle (title, titleI18nKey, stepType) {
      return title || this.$t(titleI18nKey) || this.$t(`${this.i18nPrefix}.label.stepName.${stepType}`)
    },
    getStepType () {
      return this.currentSteps[this.active].stepType
    },
    onClick (index) {
      this.$emit('onClick', index)
    },
    scrollToCenter () {
      const container = this.$refs.scrollContainer // 获取滚动容器
      const target = this.$refs.stepItem[this.active] // 获取目标元素
      // 计算目标元素的位置
      if (container && target) {
        const targetRect = target.getBoundingClientRect()
        const containerRect = container.getBoundingClientRect()
        // 计算目标元素的左偏移量
        const offset = targetRect.left - containerRect.left
        // 计算滚动到中央所需的距离
        const scrollTo = offset - (containerRect.width / 2) + (targetRect.width / 2)
        container.scrollTo({
          left: scrollTo,
          behavior: 'smooth'
        })
      }
    },
    createStepItemClassName (step) {
      return _.toLower(step.stepType)
    }
  },
  watch: {
    active: {
      handler () {
        this.scrollToCenter()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-step {
  position: relative;
  display: flex;
  overflow-x: auto;
  /* 隐藏滚动条 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer and Edge */

  .step-item {
    text-align: center;
    min-width: 16%;

    .step-top {
      height: 22px;
      margin-bottom: 14px;

      .icon-top {
        line-height: 22px;
        font-size: 20px;
        color: #909399;

        &.resume-info-icon {
          font-size: 18px;
        }
      }
    }

    .step-line {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;

      .icon-step {
        line-height: 20px;
        font-size: 20px;
        color: #909399;
      }

      .icon-active {
        font-size: 20px;
        color: var(--custom-color, #0096cc)
      }

      .icon-finish {
        font-size: 20px;
      }

      .icon-inactive {
        font-size: 12px;
      }

      .before-step {
        flex-shrink: 0;
        width: 50%;
        height: 3px;
        background-color: #c0c4cc;

        &.first-step {
          height: 0;
        }
      }

      .after-step {
        flex-shrink: 0;
        width: 50%;
        height: 3px;
        background-color: #c0c4cc;

        &.last-step {
          height: 0;
        }
      }
    }

    .step-title {

      .title {
        display: inline-block;
        font-size: 11px;
        font-weight: 300;
        line-height: 14px;
        color: #595757;
      }
    }
  }

  .active-step {
    .step-top {
      .icon-top {
        color: var(--custom-color, #0096cc);
      }
    }
  }
}

/* 对于 Webkit 浏览器（Chrome, Safari等）隐藏滚动条 */
.custom-step::-webkit-scrollbar {
  display: none; /* Safari 和 Chrome */
}
</style>
